import { useState } from 'react';

import { TCollabThread, TiptapCollabProvider } from '@tiptap-pro/provider';

import { colors } from 'theme/colors';

import { useThreadsState } from 'containers/Tiptap/components/tiptap-templates/ThreadContext';

import TabPanel from 'components/CustomTabPanel/CustomTabPanel';

import { StyledTab, StyledTabs } from './styles';
import ThreadsListItem from './ThreadsListItem';

interface CommentUIProps {
  provider: TiptapCollabProvider;
  threads: TCollabThread[];
  isOpen: boolean;
}

const CommentUI = ({ provider, threads, isOpen }: CommentUIProps): React.ReactNode => {
  const { selectedThreads, selectedThread } = useThreadsState();

  const [showUnresolved, setShowUnresolved] = useState(0);

  if (!isOpen) {
    return null;
  }

  const resolvedThreads = threads.filter((t) => !!t.resolvedAt);
  const unresolvedThreads = threads.filter((t) => !t.resolvedAt);

  return (
    <>
      {threads.length === 0 ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            borderTop: `1px solid ${colors.grey[300]}`,
          }}
        >
          <p style={{ color: colors.grey[600], fontSize: '16px' }}>No threads.</p>
        </div>
      ) : (
        <>
          <StyledTabs value={showUnresolved} onChange={(_, value) => setShowUnresolved(value)}>
            <StyledTab label="Open" value={0} />
            <StyledTab label="Resolved" value={1} />
          </StyledTabs>

          <TabPanel value={showUnresolved} index={0}>
            {unresolvedThreads.map((t) => (
              <ThreadsListItem
                key={t.id}
                thread={t}
                active={selectedThreads.includes(t.id) || selectedThread === t.id}
                open={selectedThread === t.id}
                provider={provider}
              />
            ))}
          </TabPanel>

          <TabPanel value={showUnresolved} index={1}>
            {resolvedThreads.length === 0 ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <p style={{ color: colors.grey[600], fontSize: '16px' }}>No resolved threads.</p>
              </div>
            ) : (
              resolvedThreads.map((t) => (
                <ThreadsListItem
                  key={t.id}
                  thread={t}
                  active={selectedThreads.includes(t.id) || selectedThread === t.id}
                  open={selectedThread === t.id}
                  provider={provider}
                />
              ))
            )}
          </TabPanel>
        </>
      )}
    </>
  );
};

export default CommentUI;
